/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_temp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I quickly estimate Celsius to Fahrenheit in my head?`)
};

const es_uc_temp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo estimo rápidamente Celsius a Fahrenheit en mi cabeza?`)
};

const de_uc_temp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie schätze ich Celsius in Fahrenheit schnell im Kopf?`)
};

const nl_uc_temp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe schat ik snel Celsius naar Fahrenheit in mijn hoofd?`)
};

const fr_uc_temp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment estimer rapidement Celsius en Fahrenheit dans ma tête ?`)
};

const it_uc_temp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come posso stimare velocemente Celsius in Fahrenheit nella mia testa?`)
};

const pt_br2_uc_temp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como faço para estimar rapidamente Celsius para Fahrenheit de cabeça?`)
};

const pt_uc_temp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como faço uma estimativa rápida de Celsius para Fahrenheit na minha cabeça?`)
};

const ja_uc_temp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セルシウスを頭の中でファーレンハイトにすばやく推定するにはどうすればよいですか?`)
};

const zh_uc_temp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_temp_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_temp_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_temp_faq4_q", locale)
	if (locale === "en") return en_uc_temp_faq4_q(inputs)
	if (locale === "es") return es_uc_temp_faq4_q(inputs)
	if (locale === "de") return de_uc_temp_faq4_q(inputs)
	if (locale === "nl") return nl_uc_temp_faq4_q(inputs)
	if (locale === "fr") return fr_uc_temp_faq4_q(inputs)
	if (locale === "it") return it_uc_temp_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_temp_faq4_q(inputs)
	if (locale === "pt") return pt_uc_temp_faq4_q(inputs)
	if (locale === "ja") return ja_uc_temp_faq4_q(inputs)
	return zh_uc_temp_faq4_q(inputs)
};